import {
    ContentDataDefinitionLoader,
    createRegisterableComponentWithData,
} from '@news-mono/web-common'
import React from 'react'
import { TNArticleCards, TNArticleCardsProps } from './TNArticleCards'

type Props = Omit<TNArticleCardsProps, 'data' | 'onEvent'>

export const TNArticleCardsRegistration = createRegisterableComponentWithData(
    'tn-article-cards',
    ContentDataDefinitionLoader,
    (props: Props, data, { onEvent }) => {
        return <TNArticleCards data={data} onEvent={onEvent} {...props} />
    },
)
